
import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap'

const Paginator = ({ pages, currentPage, selectPage }) =>
{
	const pageClick = (e, page) =>
	{
		e.preventDefault()
		if (page !== currentPage)
		{
			selectPage(page)
		}
	}
	
	const pagesToShow = 5
	const firstPageToShow = currentPage - Math.floor(pagesToShow / 2)
	const firstPage = firstPageToShow < 0 ? 0 : firstPageToShow
	const lastPageToShow = currentPage + Math.floor(pagesToShow / 2)
	const lastPage = lastPageToShow > pages ? pages : firstPage + pagesToShow
	const displayArray = [...Array(pages).keys()].slice(firstPage, lastPage)
	
	return (
		<Pagination className="pagination-rounded" >
			{pages && <PaginationItem disabled={currentPage === 0 || pages < pagesToShow}><PaginationLink href="#" onClick={e => pageClick(e, 0)}>&laquo;</PaginationLink></PaginationItem>}
			{pages && <PaginationItem disabled={currentPage === 0 || pages < pagesToShow}><PaginationLink href="#" onClick={e => pageClick(e, currentPage - 1)}>&lsaquo;</PaginationLink></PaginationItem>}
			{
				displayArray.map(p => (
					<PaginationItem className={ (currentPage === p) ? 'active' : '' } key={p}><PaginationLink href="#" onClick={e => pageClick(e, p)}>{p + 1}</PaginationLink></PaginationItem>
				))
			}
			{pages && <PaginationItem disabled={currentPage === (pages - 1) || pages < pagesToShow}><PaginationLink href="#" onClick={e => pageClick(e, currentPage + 1)}>&rsaquo;</PaginationLink></PaginationItem>}
			{pages && <PaginationItem disabled={currentPage === (pages - 1) || pages < pagesToShow}><PaginationLink href="#" onClick={e => pageClick(e, pages - 1)}>&raquo;</PaginationLink></PaginationItem>}
		</Pagination>
	)
}

export default Paginator
